module.exports = __webpack_public_path__ + "static/media/trusted-ifca.73a39e9d.png";